module.exports = __webpack_public_path__ + "fbfa92e04689ad577e6bdc3e3c32bec2.pdf";